import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@src/environments/environment';

declare var dataLayer: any;

@Injectable()
export class GoogleTagManagerService {
  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  setScreenName(name: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (!environment.gtmID) {
        return;
      }
      try {
        if (dataLayer) {
          dataLayer.push({
            event: 'Pageview',
            // 'url': environment.hostName + pagePath
            url: name,
          });
        }
      } catch (error) {}
    }
  }

  fireEvent(event: string, data: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (!environment.gtmID) {
        return;
      }
      try {
        if (dataLayer) {
          // LoggerService.log('Inside product click event 1 ', event, data);
          dataLayer.push({
            event,
            value: data,
          });
        }
      } catch (error) {}
    }
  }

  fireBookingEvent(event: string, data: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (!environment.gtmID) {
        return;
      }
      try {
        if (dataLayer) {
          // LoggerService.log('Inside product click event 1 ', event, data);
          const enhancedConversionData: any = {};
          if (data?.analyticsInfo?.enhanced_conversion_data?.email) {
            enhancedConversionData.email =
              data?.analyticsInfo?.enhanced_conversion_data?.email;
          }

          if (data?.analyticsInfo?.enhanced_conversion_data?.phone_number) {
            enhancedConversionData.phone_number =
              data?.analyticsInfo?.enhanced_conversion_data?.phone_number;
          }

          dataLayer.push({
            event,
            order_value: data?.analyticsInfo?.order_value,
            order_id: data?.analyticsInfo?.order_id,
            enhanced_conversion_data: enhancedConversionData,
          });
        }
      } catch (error) {}
    }
  }
}
